import { render, staticRenderFns } from "./Team.vue?vue&type=template&id=474cbac5&scoped=true"
import script from "./Team.vue?vue&type=script&lang=ts"
export * from "./Team.vue?vue&type=script&lang=ts"
import style0 from "./Team.vue?vue&type=style&index=0&id=474cbac5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474cbac5",
  null
  
)

export default component.exports